<template>
    <div>
        <div class="others-setting-page">
            <!-- 其他设置页面 -->
            <div class="others-setting-title">
                {{ $t('Setting.Integral.base_set') }}
            </div>
            <div class="mb-10" style="margin-left: 220px;">
                <el-radio
                    v-for="(item, index) in options"
                    :key="index"
                    v-model="form.enable"
                    :label="item.code"
                >{{ item.label }}</el-radio>
            </div>
            <div class="others-setting-title">{{ $t('Setting.Integral.title') }}</div>
            <div style="margin-left: 220px;">
                <div class="mb-6" style="font-weight: 500;color: #606266;">
                    {{ $t('Setting.Integral.single') }}
                    <span
                        @click="addRule()"
                        class="cursor-pointer ml-10 hover-blue"
                    >{{ $t('tooltip.add') }}</span>
                </div>
                <div v-for="(item, index) in form.rules" :key="index">
                    <div class="mt-3">
                        {{ $t('Setting.Integral.full') }}
                        <el-input style="width: 100px;" v-model="item.amount"/>
                        {{ $t('Reception.Fifth.yuan') }}，
                        {{ $t('Setting.Integral.give') }}
                        <el-input style="width: 60px;" v-model="item.point"/>
                        {{ $t('Lesson.lesson.integration') }}
                        <span
                            @click="deleteRule(index)"
                            class="cursor-pointer ml-6 hover-blue"
                        >{{ $t('tooltip.delete') }}</span>
                    </div>
                </div>
            </div>
            <div style="margin-left: 110px;" class="flex items-center">
                <div class="mb-6 mt-10" style="font-weight: 500;color: #606266;">
                    {{ $t('Setting.Integral.limi') }}
                </div>
                <div class="mt-3">
                    <el-input style="width: 110px;" v-model="form.pointLimit"/>
                    {{ $t('Choose.one') }}
                </div>
            </div>
        </div>
        <div class="mt-10 others-setting-btn">
            <el-button @click="submit()" type="primary">{{ $t('Common.save') }}</el-button>
        </div>
    </div>
</template>

<script>
import { Tabs, TabPane, Radio } from 'element-ui';

export default {
    components: {
        ElRadio: Radio,
    },
    data() {
        return {
            form: {},
            options: [
                {
                    code: true,
                    label: this.$t('Setting.Integral.on'),
                }, {
                    code: false,
                    label: this.$t('Setting.Integral.off'),
                },
            ],
        };
    },
    created() {
        this.fetchData();
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        deleteRule(index) {
            this.form.rules.splice(index, 1);
        },
        addRule() {
            this.form.rules.push({
                amount: null,
                point: null,
            });
        },
        fetchData() {
            API.get(`point`).then(res => {
                this.form = res;
            });
        },
        submit() {
            const form = Object.assign({}, this.form);
            API.put(`point`, form).then(res => {
                $ele.$message.success(this.$t('Message.success'));
                this.fetchData();
            });
        },
    },
};

</script>
<style lang="scss">
.others-setting-page {
    padding: 20px;
    border: 1px solid #e6e6e6;
}
.others-setting-title {
    font-size: 13px;
    margin-bottom: 15px;
}
.others-setting-btn {
    margin-left: 340px;
}

</style>
